"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _canvas = require("canvas");
var generateBlurUrl = function generateBlurUrl(arr, width, height) {
  return getDataUrlFromArr(arr, width, height);
};
function getDataUrlFromArr(arr, width, height) {
  if (typeof width === "undefined" || typeof height === "undefined") {
    width = height = Math.sqrt(arr.length / 4);
  }
  var canvas = new _canvas.createCanvas();
  var ctx = canvas.getContext("2d");
  canvas.width = width;
  canvas.height = height;
  var imgData = ctx.createImageData(width, height);
  imgData.data.set(arr);
  ctx.putImageData(imgData, 0, 0);
  return canvas.toDataURL();
}
var _default = generateBlurUrl;
exports["default"] = _default;